/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SaveNotificationActionData } from './SaveNotificationActionData';
import {
    SaveNotificationActionDataFromJSON,
    SaveNotificationActionDataFromJSONTyped,
    SaveNotificationActionDataToJSON,
} from './SaveNotificationActionData';

/**
 * 
 * @export
 * @interface SaveNotificationAction
 */
export interface SaveNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof SaveNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof SaveNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof SaveNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {SaveNotificationActionData}
     * @memberof SaveNotificationAction
     */
    data: SaveNotificationActionData;
}

/**
 * Check if a given object implements the SaveNotificationAction interface.
 */
export function instanceOfSaveNotificationAction(value: object): value is SaveNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function SaveNotificationActionFromJSON(json: any): SaveNotificationAction {
    return SaveNotificationActionFromJSONTyped(json, false);
}

export function SaveNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': SaveNotificationActionDataFromJSON(json['data']),
    };
}

export function SaveNotificationActionToJSON(value?: SaveNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': SaveNotificationActionDataToJSON(value.data),
    };
}

